<template>
  <div class="pages">
    <navTop :acIndex="2"></navTop>
    <div class="box">
      <!-- 内容 -->
      <div class="box-main">
        <p class="box-p">Your complaints and suggestions</p>
        <textarea
            class="box-textarea"
            v-model="content"
            placeholder="Please enter your suggestion"
        ></textarea>
        <div class="box-btn" @click="subomt">Submit</div>
      </div>
    </div>
    <navFooter></navFooter>
  </div>
</template>

<script>
import navTop from '../../components/navTop.vue';
import navFooter from '../../components/navFooter.vue';
export default {
  name: 'proposal',
  components: {
    navTop,
    navFooter
  },
  data() {
    return {
      content: ''
    };
  },
  created() {},
  methods: {
    subomt() {
      if (this.content == '') {
        this.$message({
          message: 'Please fill in the proposal before submitting',
          type: 'error',
          center: true,
          duration: 1000
        });
        return;
      }
      let data = {
        uid: sessionStorage.getItem('uid'),
        content: this.content
      };
      this.$api.opinion(data).then(res => {
        console.log(res);
        if (res.result == 0) {
          let that = this;
          that.$message({
            message: 'Successful complaint',
            type: 'success',
            center: true,
            duration: 1000,
            onClose: function () {
              that.$router.push({path: '/index'});
            }
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
// 科技蓝色风格变量 - 使用 #1ba8e8 作为主色调
$blue-primary: #1ba8e8;
$blue-primary-rgba: rgba(27, 168, 232, 0.9);
$blue-secondary: #4ab9f0;
$blue-glow: rgba(27, 168, 232, 0.4);
$blue-light: rgba(27, 168, 232, 0.2);
$blue-dark: #0f2b3f;
$text-glow: 0 0 8px rgba(27, 168, 232, 0.5);

.pages {
  background: linear-gradient(135deg, #0f2b3f 0%, #1a3f5a 100%);
  position: relative;
  min-height: 10vh;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: radial-gradient(circle at 20% 30%, rgba(27, 168, 232, 0.1) 0%, transparent 50%);
    pointer-events: none;
  }

  .box {
    padding-bottom: 70px;
    box-sizing: border-box;
    max-width: 1400px;
    margin: 0 auto;
    position: relative;
    z-index: 2;

    // 内容
    .box-main {
      margin-top: 40px;
      width: 100%;
      border-radius: 38px;
      background: rgba(15, 43, 63, 0.8);
      backdrop-filter: blur(10px);
      border: 1px solid $blue-primary-rgba;
      box-shadow: 0 0 40px $blue-glow;
      padding: 80px 200px 120px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      align-items: center;

      .box-p {
        width: 100%;
        font-size: 28px;
        color: $blue-primary;
        line-height: 1em;
        text-align: center;
        text-shadow: $text-glow;
        margin-bottom: 20px;
      }

      .box-textarea {
        margin-top: 27px;
        width: 100%;
        height: 228px;
        background: rgba(27, 168, 232, 0.1);
        border: 1px solid $blue-primary;
        outline: none;
        resize: none;
        padding: 17px 20px;
        box-sizing: border-box;
        font-size: 16px;
        font-weight: 400;
        color: $blue-primary;
        line-height: 28px;
        border-radius: 8px;
        transition: all 0.3s ease;
        box-shadow: 0 0 15px $blue-glow inset;

        &:focus {
          box-shadow: 0 0 25px $blue-primary inset;
          background: rgba(27, 168, 232, 0.15);
        }
      }

      .box-textarea::-webkit-input-placeholder {
        color: rgba(27, 168, 232, 0.6);
      }

      .box-btn {
        width: 100%;
        height: 60px;
        background: linear-gradient(
                90deg,
                rgba(27, 168, 232, 0.8) 0%,
                rgba(27, 168, 232, 0.6) 100%
        );
        font-size: 24px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        color: #ffffff;
        line-height: 60px;
        text-align: center;
        margin: 52px auto 0;
        border-radius: 8px;
        border: 1px solid $blue-primary;
        box-shadow: 0 0 20px $blue-glow;
        cursor: pointer;
        transition: all 0.3s ease;

        &:hover {
          transform: translateY(-3px);
          box-shadow: 0 5px 30px $blue-primary;
          background: linear-gradient(
                  90deg,
                  rgba(27, 168, 232, 0.9) 0%,
                  rgba(27, 168, 232, 0.7) 100%
          );
        }

        &:active {
          transform: translateY(0);
        }
      }
    }
  }
}

// 底部样式
::v-deep .footer {
  background: linear-gradient(90deg, #0f2b3f 0%, #1a3f5a 100%) !important;
  border-top: 2px solid $blue-primary !important;
  box-shadow: 0 -5px 25px $blue-glow !important;
  position: relative;
  z-index: 2;

  .footer-left {
    .logo {
      filter: drop-shadow(0 0 10px $blue-primary);
    }

    .text {
      color: #c0e4ff !important;

      span {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }
    }
  }

  .footer-right {
    .service {
      .title {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }

      .list {
        .li {
          color: #c0e4ff !important;

          &:hover {
            color: $blue-primary !important;
            text-shadow: $text-glow;
          }
        }
      }
    }

    .contact {
      .title {
        color: $blue-primary !important;
        text-shadow: $text-glow;
      }

      .item {
        color: #c0e4ff !important;

        img {
          filter: brightness(1.2) drop-shadow(0 0 5px $blue-primary);
        }
      }
    }

    .qrcode {
      border: 1px solid $blue-primary !important;
      box-shadow: 0 0 20px $blue-glow;
    }
  }

  // 其他网站区域
  .other-site {
    border-top: 1px solid rgba(27, 168, 232, 0.3) !important;
    margin-top: 30px !important;
    padding-top: 30px !important;

    .other-site-title {
      color: $blue-primary !important;
      font-size: 18px !important;
      font-weight: bold !important;
      margin-bottom: 15px !important;
      text-shadow: $text-glow;
      position: relative;
      display: inline-block;

      &::after {
        content: '';
        position: absolute;
        bottom: -5px;
        left: 0;
        width: 50px;
        height: 2px;
        background: $blue-primary;
        box-shadow: 0 0 10px $blue-primary;
      }
    }

    .other-site-links {
      display: flex !important;
      flex-wrap: wrap !important;
      gap: 15px !important;
      margin-bottom: 20px !important;

      .other-site-link-item {
        color: #c0e4ff !important;
        font-size: 14px !important;
        padding: 5px 15px !important;
        border: 1px solid rgba(27, 168, 232, 0.2) !important;
        border-radius: 20px !important;
        transition: all 0.3s ease !important;
        cursor: pointer !important;

        &:hover {
          border-color: $blue-primary !important;
          box-shadow: 0 0 15px $blue-glow !important;
          color: $blue-primary !important;
          transform: translateY(-2px);
        }
      }
    }

    .other-site-copyright {
      color: #c0e4ff !important;
      font-size: 13px !important;
      line-height: 1.8 !important;
      text-align: center !important;

      a {
        color: $blue-primary !important;
        text-decoration: none !important;
        transition: all 0.3s ease !important;

        &:hover {
          color: lighten($blue-primary, 20%) !important;
          text-shadow: $text-glow;
        }
      }

      .icp {
        color: #c0e4ff !important;
        margin: 0 5px;

        span {
          color: $blue-primary !important;
        }
      }

      .beian {
        color: #c0e4ff !important;
        margin: 0 5px;

        a {
          color: $blue-primary !important;
        }
      }

      .company {
        color: $blue-primary !important;
        font-weight: bold;
      }
    }
  }
}

// 响应式调整
@media screen and (max-width: 1200px) {
  .pages {
    .box {
      padding-left: 20px;
      padding-right: 20px;

      .box-main {
        padding: 60px 100px 100px;

        .box-p {
          font-size: 24px;
        }

        .box-textarea {
          height: 200px;
          font-size: 15px;
        }

        .box-btn {
          height: 50px;
          font-size: 20px;
          line-height: 50px;
          margin-top: 40px;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .pages {
    .box {
      .box-main {
        padding: 40px 30px 70px;

        .box-p {
          font-size: 20px;
        }

        .box-textarea {
          height: 180px;
          font-size: 14px;
        }

        .box-btn {
          height: 45px;
          font-size: 18px;
          line-height: 45px;
          margin-top: 30px;
        }
      }
    }
  }
}
</style>